export const setActiveButton = button => ({
   type: "SET_ACTIVE_BUTTON",
   button: button
});


export default (state = {name: ''}, action = {}) => {
    if(action.type === "SET_ACTIVE_BUTTON") {
        state = action.button;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/state/activeButton.js